import React from "react";

function Chapter({ text, children }) {
  return (
    <div>
      <div className="text-2xl font-semibold local-theme-text-xs mb-5 border-l-4 border-l-gray-500 pl-2">{text}</div>
      <div className="mb-10">{children}</div>
    </div>
  );
}

export default Chapter;
